import { render, staticRenderFns } from "./SysContentMange.vue?vue&type=template&id=67e6135b&scoped=true"
import script from "./SysContentMange.vue?vue&type=script&lang=js"
export * from "./SysContentMange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e6135b",
  null
  
)

export default component.exports